import { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import VideoPlayer from "@/components/VideoPlayer";

const TrackMatchingVideo = ({
  src,
  task,
  selectedTrack,
  updateSelectedTrack,
  candidateId,
}) => {
  const videoRef = useRef(null);
  const [tracks, setTracks] = useState({});
  const [colors, setColors] = useState({});

  // Compose tracks and colors if one of task, selectedTrack and candidateId has been changed
  useEffect(() => {
    const newTracks = {};
    task.candidates.forEach(([trackId, data], index) => {
      newTracks[index + 1] = data; // show track labels with index for visual convenience
    });
    newTracks["LOST"] = task.lost_track;
    setTracks({ ...newTracks });

    const newColors = {}; // Reset all colors.(Deselect all tracks)
    newColors["LOST"] = "yellow"; // Set color of the lost track
    // Get index from selectedTrackId and candidateId
    if (selectedTrack || candidateId) {
      for (let i = 0; i < task.candidates.length; i++) {
        const [trackId] = task.candidates[i];
        if (selectedTrack && Number(trackId) === Number(selectedTrack)) {
          newColors[i + 1] = "yellow"; // Selected Track Color
        }
        if (candidateId && Number(trackId) === Number(candidateId)) {
          newColors[i + 1] = "red"; // Candidate Track Color
        }
      }
    }
    setColors({ ...newColors });
  }, [task, selectedTrack, candidateId]);

  function onTrackClicked(trackIndex) {
    let trackIndexNum = Number(trackIndex) - 1; // trackIndex should be converted to a number
    var trackId = null;
    if (trackIndexNum < task.candidates.length) {
      trackId = task.candidates[trackIndexNum][0];
    }
    updateSelectedTrack(trackId);
  }

  const keyDownHandler = async (e) => {
    if (/^[1-9]$/.test(e.key)) {
      onTrackClicked(e.key);
    }
    if (e.key === "r") {
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <>
      <Row className="justify-content-center">
        <Col xs={11}>
          {task ? (
            <VideoPlayer
              ref={videoRef}
              src={src}
              fps={task.fps}
              frameStep={task.frame_step}
              startTime={task.frame_start * (1 / task.fps)}
              endTime={task.frame_end * (1 / task.fps)}
              tracks={tracks}
              colors={colors}
              videoProps={{ autoPlay: true }}
              onTrackClick={onTrackClicked}
              keyDownHandler={keyDownHandler}
              zoomArea={task.zoom_area_coordinates}
            />
          ) : null}
        </Col>
      </Row>
      <Row className="justify-content-center mt-2">
        <Col xs={"auto"}>
          <div>Enter - send data</div>
          <div>Space - play/pause</div>
          <div>You can select the desired track using the keys 1,2,3...</div>
          <div>Delete track with key - "A"</div>
        </Col>
      </Row>

      <Row className="justify-content-center mt-2 gap-2">
        {task.candidates.map(([trackId], index) => {
          return (
            <Col xs={"auto"} key={trackId}>
              <Button
                variant={trackId === selectedTrack ? "success" : "primary"}
                onClick={() => onTrackClicked(index + 1)}
              >
                Track {index + 1}
              </Button>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default TrackMatchingVideo;
